import(/* webpackMode: "eager" */ "/app/app/[locale]/agreement/error.tsx");
